import type { WordRun } from '../types';

/**
 * Phase 7: Flattening
 *
 * Flatten reordered runs back to linear word sequence.
 * This step converts the hierarchical run structure back to a flat array of words.
 */
export const flattenRuns = (runs: Array<WordRun>) => {
  return runs.flatMap(run => run.words);
};
